import type { StorePlaceRemainder } from "../../../api/storePlaces";
import { formatStorePlaceCellName } from "./formatStorePlaceCellName";

/**
 * Формирует plain-text представление ячеек остатка. \
 * Остатки в разрезе партий дедуплицируются по `SpCode` ячейки.
 * @param remainders остатки по ячейкам хранения
 * @returns уникальные обозначения ячеек через запятую или текст для пустого значения
 */
export function formatRemainderCells(remainders: StorePlaceRemainder[] | undefined): string {
    if (remainders == null || remainders.length === 0) {
        return "Не задано";
    }

    const seenSpCodes = new Set<number>();
    const cells: string[] = [];

    remainders.forEach((remainder) => {
        if (seenSpCodes.has(remainder.SpCode)) {
            return;
        }

        const cellName = formatStorePlaceCellName(remainder.StorePlace);
        if (cellName === "") {
            return;
        }

        seenSpCodes.add(remainder.SpCode);
        cells.push(cellName);
    });

    if (cells.length === 0) {
        return "Не задано";
    }

    return cells.join(", ");
}
